export default "__VITE_ASSET__Bn8X_ppn__"